'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@/i18n/navigation';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { AnimatedList } from '@/components/partials';
import LazyImage from '@/components/partials/lazy-image';
import { getResizedPictureUrl } from '@/lib/utils';
import { BrandType } from '@/types/brand';
import { VehicleGroupType } from '@/types/vehicle-group';
import { getLocalizedValue } from '@/lib/utils';
import { useAppLocale, useTranslatedRoute } from '@/hooks';
type BrandsProps = {
  brands: BrandType[];
};
type VehicleGroupsProps = {
  vehicleGroups: VehicleGroupType[];
};
export const HomeProduceBrands = t0 => {
  const $ = _c(7);
  const {
    brands
  } = t0;
  const {
    buildRoute
  } = useTranslatedRoute();
  let t1;
  if ($[0] !== brands || $[1] !== buildRoute) {
    let t2;
    if ($[3] !== buildRoute) {
      t2 = brand => {
        const logoUrl = brand.picture ? getResizedPictureUrl(brand.picture.path, 60, 30) : null;
        return <Tooltip key={brand.id}><TooltipTrigger asChild={true}><Link href={`${buildRoute("products")}?brands=${brand.slug}`} className="group hover:text-brand flex items-center gap-1.5 opacity-60 transition-all duration-300 hover:opacity-100">{logoUrl && <LazyImage src={logoUrl} alt={brand.name} width={60} height={30} className="h-5 w-auto object-contain filter-[brightness(1)_invert(0)_sepia(0)_saturate(1)_hue-rotate(0deg)] transition-[filter] duration-300 group-hover:filter-[brightness(0)_invert(0.73)_sepia(1)_saturate(10)_hue-rotate(2deg)]" />}<span>{brand.name.toLocaleUpperCase("en-US")}</span></Link></TooltipTrigger><TooltipContent><p>{brand.name}</p></TooltipContent></Tooltip>;
      };
      $[3] = buildRoute;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = brands.map(t2);
    $[0] = brands;
    $[1] = buildRoute;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <AnimatedList animation="slide-up" staggerDelay={0.1} className="flex flex-wrap items-center justify-center gap-8 text-2xl font-medium">{t1}</AnimatedList>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const HomeProduceVehicleGroups = t0 => {
  const $ = _c(9);
  const {
    vehicleGroups
  } = t0;
  const {
    backendLocale
  } = useAppLocale();
  const {
    buildRoute
  } = useTranslatedRoute();
  let t1;
  if ($[0] !== backendLocale || $[1] !== buildRoute || $[2] !== vehicleGroups) {
    let t2;
    if ($[4] !== backendLocale || $[5] !== buildRoute) {
      t2 = group => {
        const title = getLocalizedValue(group, "title", backendLocale) ?? group.id;
        const slug = getLocalizedValue(group, "slug", backendLocale);
        const pictureUrl = group.picture ? getResizedPictureUrl(group.picture.path, 400, 300) : null;
        return <Tooltip key={group.id}><TooltipTrigger asChild={true}><Link href={slug ? `${buildRoute("products")}?applications=${slug}` : buildRoute("products")} className="group w-32 opacity-60 transition-all duration-300 hover:opacity-100 hover:drop-shadow-xl sm:w-28 md:w-32 lg:w-42"><div className="relative aspect-4/3 w-full overflow-hidden rounded-lg">{pictureUrl ? <LazyImage src={pictureUrl} alt={title} fill={true} sizes="(max-width: 640px) 128px, (max-width: 768px) 112px, (max-width: 1024px) 128px, 168px" priority={true} className="object-cover transition-transform duration-500 group-hover:scale-110" /> : <span className="group-hover:border-brand group-hover:text-brand absolute inset-0 flex cursor-pointer items-center justify-center rounded-lg border p-2 text-center text-xs leading-tight font-medium transition-colors duration-300">{title}</span>}</div></Link></TooltipTrigger><TooltipContent><p>{title}</p></TooltipContent></Tooltip>;
      };
      $[4] = backendLocale;
      $[5] = buildRoute;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = vehicleGroups.map(t2);
    $[0] = backendLocale;
    $[1] = buildRoute;
    $[2] = vehicleGroups;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <AnimatedList animation="fade-scale" className="flex flex-wrap items-center justify-center gap-5">{t1}</AnimatedList>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};